// extracted by mini-css-extract-plugin
export default {"form":"Filter_form__wVnxJ","form-inputs":"Filter_form-inputs__jlP7R","form-input":"Filter_form-input__8QuZU"};